const setThreadUpdatedAt = ({ threadId, updatedAt } = {}) => {
  return {
    type: 'pieveSetThreadUpdatedAt',
    payload: {
      threadId,
      updatedAt
    }
  };
};

export default setThreadUpdatedAt;
